import clsx from 'clsx';
import { memo } from 'react';
import { SkeletonButton } from 'src/modules/common/skeletons/SkeletonButton/SkeletonButton';

type Props = {
    mobile: boolean;
    idle?: boolean;
    size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl';
    fullHeight?: boolean;
}

export const SkeletonFilter = memo(({ mobile, idle, fullHeight, size = 'md' }: Props) => (
    <div className={clsx({
        'vss-skeleton-filter': true,
        'vss-skeleton-filter--full-height': fullHeight,
    })}
    >
        {mobile ? (
            <>
                <SkeletonButton idle={idle} size={size} fullSize={true}/>

                <SkeletonButton idle={idle} size={size} fullSize={true}/>
            </>
        ) : (
            <>
                <SkeletonButton idle={idle} size={size} fullSize={true}/>

                <SkeletonButton idle={idle} size={size} fullSize={true}/>

                <SkeletonButton idle={idle} size={size} fullSize={true}/>

                <SkeletonButton idle={idle} size={size} fullSize={true}/>
            </>
        )}
    </div>
));
